import ArrayUtil from '@leverege/array-util'

import { ProjectActions, BlueprintActions } from '~/actions/'

const initialProjectState = {
  name : null,
  id : '',
  blueprints : [],
  apiAccess : []
};

function project( state = initialProjectState, action ) {
  switch ( action.type ) {

    case ProjectActions.GET_PROJECT:
      if ( state.id === action.project.id ) {
        const p = action.project
        return { ...p, blueprints : p.blueprints || state.blueprints, apiAccess : p.apiAccess || state.apiAccess }
      }
      return action.project;

    case ProjectActions.PROJECT_ERROR:
      return { error : true,
               status : action.status,
               message : action.message };

    case ProjectActions.ADD_BLUEPRINT: {

      const nState = { ...state }
      nState.blueprints = [].concat( state.blueprints || [] )
      nState.blueprints.push( action.blueprint );
      return nState;
    }

    case BlueprintActions.UPDATE_BLUEPRINT: {
      const nState = { ...state }
      nState.blueprints = [].concat( state.blueprints || [] )
      if ( action.blueprint.projectId != state.id ) {
      // transfer out of project
        ArrayUtil.remove( nState.blueprints, 'id', action.blueprint.id )
      } else {
        ArrayUtil.replace( nState.blueprints, 'id', action.blueprint.id, action.blueprint )
      }
      return nState;
    }

    case ProjectActions.REMOVE_BLUEPRINT: {
      const nState = { ...state }
      nState.blueprints = [].concat( state.blueprints || [] )
      const index = ArrayUtil.remove( nState.blueprints, 'id', action.blueprint.id );
      if ( index >= 0 ) {
        return nState;
      }
      return state; // no change
    }

    default: 
      return state
  }
}

module.exports = project;
